module.exports = __webpack_public_path__ + "static/media/Limitless_diamonds_2024-12-17.132f2110.pdf";